import {configureStore} from '@reduxjs/toolkit';
import yearReducer from './yearSlice';
import filterReducer from './Filters';
import questionReducer from './QuestionsSlice';
import mobileDisplays from './mobileDisplays';
import translationsReducer from './translationSlice';

export const store = configureStore({
  reducer: {
    selectedYear: yearReducer,
    showFilters: filterReducer,
    questions: questionReducer,
    translations: translationsReducer,
    mobileDisplays: mobileDisplays,
  },
});
